import React, { useEffect, useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Editor from "../../common/Editor";
import { MODE_CREATE, MODE_EDIT, QUANTITY_REGEX } from "../../codes";
import { useMutation } from "@tanstack/react-query";
import useToast from "../../util/useToast";
import { PurchaseErrors } from "../../errors/ErrorsMapping";
import { apiCreatePurchase, apiUpdatePurchase } from "../../api/ApiPurchases";

const PurchaseEditor = ({show, mode, hide, onSubmit, purchase = {}}) => {
  const {showToastSuccess} = useToast();

  const [formErrors, setFormErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    color: "#555555|#FFFFFF",
    addresses: [],
    emails: [],
    phones: []
  });

  const nameRef = useRef(null);

  const createMutation = useMutation(apiCreatePurchase());
  const editMutation = useMutation(apiUpdatePurchase(purchase.id));

  useEffect(() => {
    if (show) {
      setFormErrors({});

      nameRef.current.focus();

      setFormData({
        name: purchase.name || "",
        quantity: purchase.quantity || "1",
      });
    }
  }, [show, purchase]);

  const submit = () => {
    let promise;

    if (mode === MODE_EDIT) {
      promise = editMutation.mutateAsync(formData);
    } else {
      promise = createMutation.mutateAsync(formData);
    }

    return promise
      .then(() => {
        return (onSubmit ? onSubmit() : Promise.resolve()).then(() => {
          if (mode === MODE_EDIT) {
            showToastSuccess("Matériel à acheter modifié");
          } else {
            showToastSuccess("Matériel à acheter ajouté");
          }
        });
      })
      .then(hide)
      .catch((err) => {
        if (err.response?.status === 400) {
          setFormErrors(err.response.data.errors);
        }
      });
  };

  const updateFormData = (field, context = null) => e => {
    const values = {};

    switch (field) {
      case "quantity":
        if (QUANTITY_REGEX.test(e.target.value)) {
          values.quantity = e.target.value.replace(",", ".");
        }
        break;
      default:
        values[field] = e.target.value;
        break;
    }

    setFormData(prev => ({...prev, ...values}));
  };

  return <Editor
    show={show}
    title={mode === MODE_CREATE ? "Ajouter un matériel à acheter" : "Modifier un matériel à acheter"}
    onSubmit={submit}
    onCancel={hide}
    submitLabel="Sauvegarder"
    cancelLabel="Annuler"
  >
    <Form.Group className="mb-2" controlId="purchase-editor-name">
      <Row>
        <Form.Label column sm={3}>Nom</Form.Label>
        <Col sm={9}>
          <Form.Control
            type="text"
            value={formData.name}
            onChange={updateFormData("name")}
            maxLength="255"
            ref={nameRef}
            isInvalid={!!formErrors.name}
          />

          <Form.Control.Feedback type="invalid">{PurchaseErrors.name[formErrors.name]}</Form.Control.Feedback>
        </Col>
      </Row>
    </Form.Group>

    <Form.Group className="mb-2" controlId="purchase-editor-quantity">
      <Row>
        <Form.Label column sm={3}>Quantité</Form.Label>
        <Col sm={9}>
          <Form.Control
            type="text"
            value={formData.quantity}
            onChange={updateFormData("quantity")}
            maxLength="255"
            isInvalid={!!formErrors.quantity}
          />

          <Form.Control.Feedback type="invalid">{PurchaseErrors.quantity[formErrors.quantity]}</Form.Control.Feedback>
        </Col>
      </Row>
    </Form.Group>
  </Editor>;
};

export default PurchaseEditor;